import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { AnnonceService } from '../annonce.service';

@Component({
  selector: 'app-annonce-attente',
  templateUrl: './annonce-attente.component.html',
  styleUrls: ['./annonce-attente.component.scss']
})
export class AnnonceAttenteComponent implements OnInit {
  agencies: any[] = [];
  announcements: any[] = [];
  loading = false;
  p = 1;
  search_name = '';

  constructor(private announceService: AnnonceService) {}

  ngOnInit(): void {
    this.loadAnnouncements();
  }

  loadAnnouncements(): void {
    this.loading = true;
    this.announceService.getAnnouncementsAttente().subscribe({
      next: (data: any[]) => {
        this.announcements = data || [];
        // Reverse to show newest first
        this.agencies = [...this.announcements].reverse();
        this.loading = false;
        console.log('Loaded agencies:', this.agencies);
      },
      error: (err) => {
        console.error(err);
        this.agencies = [];
        this.loading = false;
        Swal.fire('Erreur', 'Impossible de charger les annonces', 'error');
      }
    });
  }

  AnnouncementNonVu(): void {
    this.loadAnnouncements();
  }

  deleteAgencies(id: string, index: number): void {
    Swal.fire({
      title: 'Supprimer ?',
      text: 'Cette action est irréversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Oui, supprimer'
    }).then((result) => {
      if (result.isConfirmed) {
        this.announceService.deleteItem(id).subscribe({
          next: () => {
            this.agencies.splice(index, 1);
            Swal.fire('Supprimé!', 'L\'annonce a été supprimée.', 'success');
          },
          error: () => Swal.fire('Erreur', 'Suppression impossible', 'error')
        });
      }
    });
  }

  // Safe filter method (replaces the pipe)
  filteredAgencies(): any[] {
    if (!this.search_name || this.search_name.trim() === '') {
      return this.agencies;
    }
    const term = this.search_name.toLowerCase();
    return this.agencies.filter(a =>
      a.AnnonceName?.toLowerCase().includes(term) ||
      a.ville?.toLowerCase().includes(term)
    );
  }

  onCityChange(event: any): void {
    const city = event.target.value;
    if (!city) {
      this.agencies = [...this.announcements].reverse();
    } else {
      this.agencies = this.announcements.filter(a => a.ville === city).reverse();
    }
    this.p = 1; // reset pagination
  }

  approveA(id: string): void {
    this.announceService.approveAnnouncement(id).subscribe({
      next: () => {
        Swal.fire('Approuvé !', 'L\'annonce a été approuvée.', 'success');
        this.loadAnnouncements();
      },
      error: () => Swal.fire('Erreur', 'Approbation impossible', 'error')
    });
  }
}